import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Form from 'react-bootstrap/Form'
import axios from 'axios'
import { toast } from 'react-toastify';

export class CataloguesEdit extends React.Component {
  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    catalogue: {},
    catalogueDetails: []
  }

  componentWillMount() {
    this.fetchCatalogue();
    this.fetchCatalogueDetails()
  }

  handleChange (evt) {
    var catalogueDetails = this.state.catalogueDetails
    var index = catalogueDetails.findIndex(e => e.productID == evt.target.id);
    catalogueDetails[index].inCatalogue = evt.target.checked
    this.setState({ catalogueDetails: catalogueDetails });
  }

  filterChange(evt) {
    this.refs.nameFilter.applyFilter(evt.target.value);
  }

  fetchCatalogue = async () => {
    axios.get('/catalogues/' + this.props.match.params.id)
        .then(data => {
          this.setState({
            catalogue: data[0]
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to fetch catalogue record')
        })
  }

  fetchCatalogueDetails = async () => {
    axios.get('/catalogues/' + this.props.match.params.id + '/details')
        .then(data => {
          this.setState({
            catalogueDetails: data
          });
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to fetch catalogue details')
        })
  }

  saveChanges = async () => {
    let requestParams = {
      'catalogueID': this.props.match.params.id,
      'catalogueDetails': this.state.catalogueDetails
    }
    axios.post('/catalogues/details/edit', requestParams)
        .then(data => {
          toast.success('Catalogue Saved!')
          this.props.history.push("/catalogues")
        })
          .catch (err => {
            console.error(err)
            Rollbar.error(err)
            toast.error('Failed to save catalogue')
          })
  }

  editCatalogue(cell, row, enumObject, rowIndex) {
    return (
      <Form.Check 
        custom
        type={'checkbox'}
        label="#"
        id={row.productID}
        checked={row.inCatalogue}
        onChange={(e) => {this.handleChange(e)}}
      />
    )
  }

    render() {
        return (
          <div>
            {this.state.catalogue ? 
            <div>
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Edit Catalogue - <span className="text-success">{this.state.catalogue.catalogueName}</span></h1>
              </div>
              <div className="row">
                <div className="col-sm-8 my-auto">
                  <button type="button" onClick={() => this.saveChanges()} className="btn btn-success btn-sm mar-bot mar-right">Save Changes</button>
                </div>
                <div className="col-sm-4 my-auto">
                  <div className="input-group mar-bot">
                    <div className="input-group-prepend">
                      <span className="input-group-text"><i className="fa fa-search"></i></span>
                    </div>
                    <input type="text" className="form-control" placeholder="Product name..." onChange={this.filterChange.bind(this)}/>
                  </div>
                </div>
              </div>
              <BootstrapTable data={this.state.catalogueDetails} striped={true} hover={true} options={{sizePerPage: 50}} pagination>
                <TableHeaderColumn ref='nameFilter' dataField="productName" isKey={true} dataSort={true} filter={{ type: 'TextFilter' }}>Product Name</TableHeaderColumn>
                <TableHeaderColumn dataField="categoryName" dataSort={true} filter={{ type: 'TextFilter' }}>Product Category</TableHeaderColumn>
                <TableHeaderColumn dataSort={true} dataFormat={this.editCatalogue.bind(this)}>In Catalogue</TableHeaderColumn>
              </BootstrapTable>
            </div> : null}
          </div>
        );
    }
}
